export default {
  plural: 'Мітки',
  singular: 'Мітка',
  new: 'Нова мітка',
  add: 'Додати мітки',
  change: 'Змінити мітки',
  createTag: 'Створити тег',
  createTeamCustomTag: 'Створити кастомний тег компанії',
  deleteTag: 'Видалити тег',
  deleteWarning:
    'Ви впевнені, що хочете видалити тег? Цю дію неможливо скасувати.',
  tagType: 'Тип тегу',
  select: 'Обрати мітки...',
  removeAllOtherTags: 'Видалити усі інші теги',
  no: 'Мітки відсутні'
};
